import React from 'react';
import GridContainer from '@/components/Grid/GridContainer';
import CustomInput from '@/components/CustomInput/CustomInput';
import Button from '@/components/CustomButtons/Button';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import GridItem from '@/components/Grid/GridItem';

export default function ReportingColumnList({
  columns,
  onUpdateColumn,
  onRemoveColumn,
  onAddColumn,
  availableColumns,
  isDisabled,
  columnTypeLabel = 'Column',
}) {
  return (
    <>
      {columns?.map((column, index) => (
        <GridContainer key={index}>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              type='text'
              labelText={`${columnTypeLabel} Name`}
              onChange={(e) =>
                onUpdateColumn(index, 'column_name', e.target.value)
              }
              value={column.column_name}
              disabled={isDisabled}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <div className='custom-select'>
              <FormControl fullWidth variant='standard'>
                <InputLabel id={`available-${columnTypeLabel}-label-${index}`}>
                  Available Columns
                </InputLabel>
                <Select
                  labelId={`available-${columnTypeLabel}-label-${index}`}
                  id={`available-${columnTypeLabel}-${index}`}
                  value={column.variable_name}
                  onChange={(e) =>
                    onUpdateColumn(index, 'variable_name', e.target.value)
                  }
                  disabled={isDisabled}>
                  {availableColumns?.map((col) => (
                    <MenuItem key={col.value} value={col.value}>
                      {col.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </GridItem>
          {column.variable_name === 'custom' && (
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                type='text'
                labelText='Custom Hardcoded Value'
                onChange={(e) =>
                  onUpdateColumn(index, 'column_custom_value', e.target.value)
                }
                value={column.column_custom_value}
                name='column_custom_value'
                formControlProps={{
                  fullWidth: true,
                }}
                disabled={isDisabled}
              />
            </GridItem>
          )}
          {column.variable_name !== 'custom' && (
            <GridItem xs={12} sm={12} md={4}>
              <div className='custom-select'>
                {column.variable_name &&
                  availableColumns.find(
                    (col) => col.value === column.variable_name,
                  )?.formats && (
                    <FormControl variant='standard' fullWidth>
                      <InputLabel id={`format-label-${index}`}>
                        Format
                      </InputLabel>
                      <Select
                        labelId={`format-label-${index}`}
                        id={`format-${index}`}
                        name='format'
                        value={column.format}
                        onChange={(e) =>
                          onUpdateColumn(index, 'format', e.target.value)
                        }
                        disabled={isDisabled}>
                        {availableColumns
                          .find((col) => col.value === column.variable_name)
                          ?.formats?.map((format) => (
                            <MenuItem key={format.value} value={format.value}>
                              {format.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  )}
              </div>
            </GridItem>
          )}
          <GridItem xs={12} sm={12} md={12}>
            <Button
              style={{ marginTop: '10px' }}
              onClick={() => onRemoveColumn(index)}
              color='danger'
              disabled={isDisabled}>
              Remove
            </Button>
          </GridItem>
        </GridContainer>
      ))}

      <div>
        <Button
          style={{ marginTop: '10px' }}
          onClick={onAddColumn}
          color='primary'
          disabled={isDisabled}>
          Add {columnTypeLabel}
        </Button>
      </div>
    </>
  );
}
